import * as Types from "../actions/Types";

const INITIAL_STATE = {
  isCreating: false,
  isUpdating: false,
  errorCreating: false,
  errorUpdating: false,
  isFetching: false,
  errorFetching: false,
  data: []
};

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action;

  switch (type) {
    case Types.CREATE_COMMUNITY:
      return {
        ...state,
        isCreating: true,
        errorCreating: false
      };
    case Types.UPDATE_COMMUNITY:
      return {
        ...state,
        isUpdating: true
      };
    case Types.UPDATE_COMMUNITY_SUCCESS:
      const updatedIndex = state.data.indexOf(
        state.data.find(comm => comm.id === payload.id)
      );

      const newData = [...state.data];
      newData[updatedIndex] = { ...newData[updatedIndex], ...payload };

      return {
        ...state,
        isUpdating: false,
        errorUpdating: false,
        data: [...newData]
      };
    case Types.UPDATE_COMMUNITY_FAILED:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: true
      };
    case Types.CREATE_COMMUNITY_SUCCESS:
      return {
        ...state,
        isCreating: false,
        errorCreating: false,
        data: [...state.data, payload]
      };

    case Types.DELETE_COMMUNITY_SUCCESS:
      return {
        ...state,
        data: state.data.filter(item => item.id !== payload)
      };

    case Types.CREATE_COMMUNITY_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: true
      };

    case Types.GET_COMMUNITIES:
      return {
        ...state,
        isFetching: true,
        errorFetching: false
      };
    case Types.GET_COMMUNITIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorFetching: false,
        data: payload
      };
    case Types.GET_COMMUNITIES_FAILED:
      return {
        ...state,
        isFetching: false,
        errorFetching: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/reducers/Communities.js